import type { Picture } from "~/core";

type GetPictureOutput = {
  id: string;
  mdId: string;
  dId: string;
  mHeight?: number;
  mWidth?: number;
  mdWidth?: number;
  mdHeight?: number;
  dWidth?: number;
  dHeight?: number;

  mColor?: string;
  mdColor?: string;
  dColor?: string;

  altText: string;
};
export const getPictureData = (picture?: Picture): GetPictureOutput => {
  const id = picture?.image?.id ?? "";
  const mdId = picture?.tablet_image?.id ?? id;
  const dId = picture?.desktop_image?.id ?? mdId;

  const mWidth = picture?.mobile_image_width ?? undefined;
  const mHeight = picture?.mobile_image_height ?? undefined;

  const mdWidth = picture?.tablet_image_width ?? mWidth;
  const mdHeight = picture?.tablet_image_height ?? mHeight;

  const dWidth = picture?.desktop_image_width ?? mdWidth;
  const dHeight = picture?.desktop_image_height ?? mdHeight;

  const mColor = picture?.color ?? undefined;
  const mdColor = picture?.tablet_color ?? mColor;
  const dColor = picture?.desktop_color ?? mdColor;

  const altText = picture?.alternative_text ?? "";

  return {
    id,
    mdId,
    dId,
    mWidth,
    mHeight,
    mdWidth,
    mdHeight,
    dHeight,
    dWidth,
    dColor,
    mdColor,
    mColor,
    altText,
  };
};
